module.exports = __webpack_public_path__ + "img/companylogo3.2ace2f01.png";